module.exports = __webpack_public_path__ + "static/podcast-hero-tablet.553cc05b.webp";